export default "__VITE_ASSET__DMB1qJo0__"